<div fxLayout="column">
  @if (showData) {
    <app-retailer-details [id]="retailerId" [header]="'Applicant Information'"
                          [createLease]="false" *ngIf="retailerId" [offering]="offering!"></app-retailer-details>

    <mat-divider fxFlexOffset="30px"></mat-divider>

    <app-applicant-results [id]="retailerId"  *ngIf="retailerId"></app-applicant-results>
  }
</div>
